import { localeStore } from './locale-store';
import { type TranslationValues, translate } from './translate';

/** For code outside components (toasts, helpers); components use `useTranslation`. */
export function t(key: string, values?: TranslationValues): string {
  return translate(localeStore.read(), key, values);
}
